export enum PropertytemEnum {
    FLOAT = 'FLOAT',
    // STRING = 'STRING',
    TEXT = 'TEXT',
    ARRAY = 'ARRAY',
    FILE = 'FILE',
    // BOOLEAN = 'BOOLEAN',
    // INT = 'INT',
    RADIO = 'RADIO',
    // new

    BOOLEAN = 'BOOLEAN',
    STRING = 'STRING',
    LIST = 'LIST',
    INT = 'INT',
    REAL = 'REAL',
}

export type TPropertyItemEnum = keyof typeof PropertytemEnum;
